import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { JwtAuthenticationService } from '../services/jwt-authentication.service';
import { AuthenticationUserResponse } from '../interfaces/authentication-user.response';

/**
 * This directive displays the given component, if it has authentication.
 *
 * @example <div *appShowAuthed="true"></div>
 * @export
 * @class ShowAuthedDirective
 * @implements {OnInit}
 */
@Directive({ selector: '[appShowAuthed]' })
export class ShowAuthedDirective implements OnInit {
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly userService: JwtAuthenticationService<AuthenticationUserResponse>,
    private readonly viewContainer: ViewContainerRef
  ) {}

  private condition: boolean;

  public ngOnInit() {
    this.userService.isAuthenticated.subscribe((authed) => {
      if ((authed && this.condition) || (!authed && !this.condition)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  @Input()
  set appShowAuthed(condition: boolean) {
    this.condition = condition;
  }
}
